import './Recipes.css';
import React from "react";
import { useParams } from 'react-router-dom';
import recipeList from "../assets/constants/recipeList.js";

function Recipe() {
    let params = useParams();
    console.log(params.recipeName);

    let recipeSelected = recipeList.find((recipe) => recipe.href === params.recipeName)
    if (typeof recipeSelected === "undefined") {
        return (
            <div className="notValid">
                <p className="notValidText"> {params.recipeName} is not a valid recipe</p>
            </div>
        )
    }

    return (
        <div className="recipeScreen">
            <h1 className="recipeHeader"> {recipeSelected.name}</h1>
            <img className="bowlPhoto" src={recipeSelected.imgSrc} alt={recipeSelected.name} />
            <p className="descriptionText"> {recipeSelected.description1} </p>
            <p className="descriptionText"> {recipeSelected.description2} </p>
            <div style={{display: 'flex'}}>
                <img className="bowlPhoto bowlPhotoSmall" src={recipeSelected.imgSrc2} alt={recipeSelected.name} />
                <p className="descriptionText"> {recipeSelected.description3} </p>
            </div>
            <p className="descriptionText"> {recipeSelected.description4} </p>
            <h1 className="recipeHeader"> {recipeSelected.ingredientRecipeName}</h1>
            <p className="ingredientsHeaderText"> ingredients: </p>
            <ul className="recipeListUl">
            {recipeSelected.ingredients.map((ingredient, index) => (
                  <li className="" key={index}>
                    {ingredient}
                  </li>
                  ))}
            </ul>
            <p className="ingredientsHeaderText"> steps: </p>
            <ul className="recipeListUl">
            {recipeSelected.steps.map((step, index) => (
                  <li className="" key={index}>
                    {step}
                  </li>
                  ))}
            </ul>
            <h1 className="recipeHeader"> {recipeSelected.noodleRecipeName}</h1>
            <p className="ingredientsHeaderText"> ingredients: </p>
            <ul className="recipeListUl">
            {recipeSelected.ingredientsNoodle.map((ingredient, index) => (
                  <li className="" key={index}>
                    {ingredient}
                  </li>
                  ))}
            </ul>
            <p className="ingredientsHeaderText"> steps: </p>
            <ul className="recipeListUl">
            {recipeSelected.stepsNoodle.map((noodleStep, index) => (
                  <li className="" key={index}>
                    {noodleStep}
                  </li>
                  ))}
            </ul>
        </div>
    )
}

export default Recipe;